import React from 'react';
import { IonCard, IonCardContent, IonIcon } from '@ionic/react';

interface Props {
  title: string;
  value: string | number;
  color?: string;
  icon?: string;
}

const StatsCard: React.FC<Props> = ({ title, value, color = '#3880ff', icon }) => {
  return (
    <IonCard style={{ textAlign: 'center' }}>
      <IonCardContent>
        {icon && <IonIcon icon={icon} style={{ fontSize: 28, color, marginBottom: 4 }} />}
        <div style={{ fontSize: 28, fontWeight: 'bold', color }}>{value}</div>
        <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>{title}</div>
      </IonCardContent>
    </IonCard>
  );
};

export default StatsCard;
